// TODO - REMOVE THIS COMMENTED CODE AFTER ASSET COLUMN IS FINALIZED

// import React, { useEffect, useMemo, useRef, useState } from "react";
// import { useForm } from "react-hook-form";
// import { yupResolver } from "@hookform/resolvers/yup";
// import Select from "react-select";
// import { Button, Form } from "react-bootstrap";
// import { assetColumnSchema, getAssetColumnSchema } from "../../yup";
// import styles from "./index.module.css";
// import {
//   createAssetColumn,
//   getAssetColumns,
//   getAssetZohoLabels,
//   updateAssetColumn,
// } from "../../service/api";
// import { showNotification } from "../../service/showNotification";
// import { convertFormula, revertFormula } from "../../utils/assetColumnFormula";
// import { ButtonLoader } from "../ButtonLoader";
// import CreatableSelect from "react-select/creatable";

// const dataTypeOptions = [
//   { value: "string", label: "String" },
//   { value: "number", label: "Number" },
//   { value: "boolean", label: "Boolean" },
// ];

// // const colId = "";

// const Column = ({ colId, zohoLabels, columns }) => {
//   // const [zohoAssetOptions, setZohoAssetOptions] = useState([]);
//   const [zohoAssetLoader, setZohoAssetLoader] = useState(false);
//   // const [formulaOptions, setFormulaOptions] = useState([]);

//   // const [inputValue, setInputValue] = useState("");
//   const [filteredOptions, setFilteredOptions] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const inputRef = useRef(null);
//   const [submitLoader, setSubmitLoader] = useState(false);

//   const {
//     reset,
//     watch,
//     setValue,
//     register,
//     handleSubmit,
//     formState: { errors },
//   } = useForm({
//     resolver: yupResolver(assetColumnSchema),
//     defaultValues: {
//       dataType: dataTypeOptions[0].value,
//       defaultValue: undefined,
//       validation: {
//         required: false,
//       },
//     },
//   });

//   // console.log("errors", errors, watch());

//   const isStringDataType = watch("dataType") === "string";
//   const isNumDataType = watch("dataType") === "number";
//   const selectedZohoLabels = watch("zohoLabel");
//   const selectedDataType = watch("dataType");
//   const isFormula = watch("isFormula") ?? false;
//   const selectedCsvLabels = watch("csvLabel") || [];
//   const isValidationRequired = watch("validation.required") ?? false;
//   const formula = watch("formula");
//   const showValidationToggle = isStringDataType || isNumDataType;
//   const showFormulaToggle = !selectedCsvLabels.length;

//   const zohoAssetOptions =
//     zohoLabels?.map((item) => ({
//       label: item?.label,
//       value: item?.api_name,
//     })) || [];

//   const formulaOptions =
//     columns?.map((item) => ({
//       label: item?.label.replaceAll(" ", "_"),
//       value: item?._id,
//     })) || [];

//   console.log("options", zohoAssetOptions, formulaOptions);

//   //formula field
//   const handleFormulaChange = (e) => {
//     const value = e.target.value;
//     // setInputValue(value);
//     setValue("formula", value);

//     const cursor = e.target.selectionStart;
//     const hashIndex = value.lastIndexOf("#", cursor - 1);
//     const afterHash = value.slice(hashIndex + 1, cursor);

//     if (hashIndex !== -1 && !/\s/.test(afterHash)) {
//       const matches = formulaOptions.filter((opt) =>
//         opt.label.toLowerCase().includes(afterHash.toLowerCase())
//       );
//       setFilteredOptions(matches);
//       setShowDropdown(true);

//       const rect = e.target.getBoundingClientRect();
//     } else {
//       setShowDropdown(false);
//     }
//   };

//   //formula field
//   const handleSelect = (option) => {
//     const cursor = inputRef.current.selectionStart;
//     const hashIndex = formula.lastIndexOf("#", cursor - 1);
//     const before = formula.slice(0, hashIndex);
//     const after = formula.slice(cursor);
//     const newValue = `${before}#${option.label} ${after}`;

//     // setInputValue(newValue);
//     setValue("formula", newValue);
//     setShowDropdown(false);
//     inputRef.current.focus();
//   };

//   // useEffect(() => {
//   //   fetchAssetZohoLabels();
//   //   fetchColumns();
//   // }, []);

//   useEffect(() => {
//     if (!colId) return;

//     const col = columns?.find((item) => colId === item._id);
//     console.log("col", col);

//     if (col) {
//       reset({
//         label: col.label,
//         csvLabel: col.csvLabel,
//         zohoLabel: col.zohoLabel,
//         dataType: col.dataType,
//         validation: col.validation,
//         defaultValue: col.defaultValue,
//         isFormula: col.isFormula,
//         formula: col.isFormula
//           ? revertFormula(col?.formula, formulaOptions)
//           : undefined,
//       });
//     }
//   }, [colId]);

//   useEffect(() => {
//     setValue("isFormula", false);
//   }, [showFormulaToggle]);

//   useEffect(() => {
//     //for formula field
//     const handler = (e) => {
//       if (!inputRef.current?.contains(e.target)) {
//         setShowDropdown(false);
//       }
//     };
//     window.addEventListener("click", handler);
//     return () => window.removeEventListener("click", handler);
//   }, []);

//   return (
//     <form onSubmit={handleSubmit(onSubmit)} className={styles.formContainer}>
//       <div className={styles.inputContainer}>
//         <label className={styles.inputLabel}>Column Name</label>
//         <input
//           {...register("label")}
//           className={styles.inputBox}
//           placeholder="Enter column name"
//         />
//         {errors?.label && (
//           <p className={styles.error}>{errors?.label?.message}</p>
//         )}
//       </div>
//       <div className={styles.inputContainer}>
//         <label className={styles.inputLabel}>Zoho Label</label>
//         <Select
//           isLoading={zohoAssetLoader}
//           options={zohoAssetOptions}
//           value={zohoAssetOptions.find(
//             (item) => item.value === selectedZohoLabels
//           )}
//           onChange={(selected) =>
//             setValue("zohoLabel", selected?.value, { shouldValidate: true })
//           }
//           menuPlacement="auto"
//           styles={{ menuList: (base) => ({ ...base, maxHeight: 160 }) }}
//         />
//         {errors.zohoLabel && (
//           <p className={styles.error}>{errors.zohoLabel.message}</p>
//         )}
//       </div>
//       <div className={styles.inputContainer}>
//         <label className={styles.inputLabel}>CSV Label</label>
//         <CreatableSelect
//           isMulti
//           options={[]}
//           value={selectedCsvLabels.map((label) => ({
//             label, // Displayed text
//             value: label, // Underlying value
//           }))}
//           onChange={(selected) => {
//             const values = selected ? selected.map((item) => item.value) : [];
//             setValue("csvLabel", values, { shouldValidate: true });
//           }}
//           onCreateOption={(inputValue) => {
//             const cleanedValue = inputValue.trim();
//             if (cleanedValue && !selectedCsvLabels.includes(cleanedValue)) {
//               const newLabels = [...selectedCsvLabels, cleanedValue];
//               setValue("csvLabel", newLabels, { shouldValidate: true });
//             }
//           }}
//           placeholder="Type and select or create labels..."
//           classNamePrefix="react-select"
//           formatCreateLabel={(inputValue) => `Create "${inputValue}"`}
//           noOptionsMessage={() => "Enter CSV column for mapping."}
//         />
//         {errors?.csvLabel && (
//           <p className={styles.error}>{errors?.csvLabel?.message}</p>
//         )}
//       </div>

//       <div className={styles.inputContainer}>
//         <label className={styles.inputLabel}>Data Type</label>
//         <Select
//           options={dataTypeOptions}
//           value={dataTypeOptions.filter((opt) => selectedDataType == opt.value)}
//           onChange={(selected) => {
//             setValue("dataType", selected?.value, { shouldValidate: true });
//           }}
//           menuPlacement="auto"
//           styles={{ menuList: (base) => ({ ...base, maxHeight: 160 }) }}
//         />
//         {errors?.dataType && (
//           <p className={styles.error}>{errors?.dataType?.message}</p>
//         )}
//       </div>

//       {showValidationToggle && (
//         <div className={styles.addValidationContainer}>
//           <label className={styles.inputLabel}>Add Validation</label>
//           <Form.Check
//             type="switch"
//             checked={isValidationRequired}
//             onChange={(e) => setValue("validation.required", e.target.checked)}
//           />
//         </div>
//       )}

//       {isValidationRequired && isStringDataType && (
//         <div className={styles.dataTypeOptions}>
//           <div className={styles.inputContainer}>
//             <label>Min Length</label>
//             <input
//               type="number"
//               {...register("validation.minLength")}
//               className={styles.inputBox}
//             />
//             {errors?.validation?.minLength && (
//               <p className={styles.error}>
//                 {errors?.validation?.minLength?.message}
//               </p>
//             )}
//           </div>
//           <div className={styles.inputContainer}>
//             <label>Max Length</label>
//             <input
//               type="number"
//               {...register("validation.maxLength")}
//               className={styles.inputBox}
//             />
//             {errors?.validation?.maxLength && (
//               <p className={styles.error}>
//                 {errors?.validation?.maxLength?.message}
//               </p>
//             )}
//           </div>
//         </div>
//       )}

//       {isValidationRequired && isNumDataType && (
//         <div className={styles.dataTypeOptions}>
//           <div className={styles.inputContainer}>
//             <label>Min</label>
//             <input
//               type="number"
//               {...register("validation.min")}
//               className={styles.inputBox}
//             />
//             {errors?.validation?.min && (
//               <p className={styles.error}>{errors?.validation?.min?.message}</p>
//             )}
//           </div>
//           <div className={styles.inputContainer}>
//             <label>Max</label>
//             <input
//               type="number"
//               {...register("validation.max")}
//               className={styles.inputBox}
//             />
//             {errors?.validation?.max && (
//               <p className={styles.error}>{errors?.validation?.max?.message}</p>
//             )}
//           </div>
//         </div>
//       )}

//       <div className={styles.inputContainer}>
//         <label className={styles.inputLabel}>Default value</label>
//         <input
//           {...register("defaultValue")}
//           className={styles.inputBox}
//           placeholder="Enter default value for the column"
//         />
//         {errors?.defaultValue && (
//           <p className={styles.error}>{errors?.defaultValue?.message}</p>
//         )}
//       </div>

//       {showFormulaToggle && (
//         <div className={styles.addValidationContainer}>
//           <label className={styles.inputLabel}>Add Formula</label>
//           <Form.Check
//             type="switch"
//             checked={isFormula}
//             onChange={(e) => setValue("isFormula", e.target.checked)}
//           />
//         </div>
//       )}

//       {isFormula && (
//         <div className={styles.inputContainer}>
//           <div className={styles.wrapper}>
//             <label className={styles.label}>Formula</label>
//             <input
//               type="text"
//               {...register("formula")}
//               className={styles.input}
//               placeholder="Enter formula (type # to use column names)"
//               value={formula}
//               onChange={handleFormulaChange}
//               ref={inputRef}
//               autoComplete="off"
//             />

//             {showDropdown && (
//               <div className={styles.dropdown}>
//                 {filteredOptions.length === 0 ? (
//                   <div className={styles.option}>No matches</div>
//                 ) : (
//                   filteredOptions.map((opt) => (
//                     <div
//                       key={opt.value}
//                       className={styles.option}
//                       onClick={() => handleSelect(opt)}
//                     >
//                       {opt.label}
//                     </div>
//                   ))
//                 )}
//               </div>
//             )}
//           </div>
//         </div>
//       )}

//       <Button
//         type="submit"
//         isDisabled={submitLoader}
//         className={styles.submitButton}
//       >
//         {submitLoader ? <ButtonLoader show={true} /> : "Submit"}
//       </Button>
//     </form>
//   );
// };

// export default Column;

import React, { useState, useEffect, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Select from "react-select";
import { Button, Form } from "react-bootstrap";
import CreatableSelect from "react-select/creatable";
import { showNotification } from "../../service/showNotification";
import { createAssetColumn, updateAssetColumn } from "../../service/api";
import { convertFormula, revertFormula } from "../../utils/assetColumnFormula";
import { assetColumnSchema } from "../../yup";
import styles from "./index.module.css";
import clsx from "clsx";

// Individual cell components with React Hook Form integration
const TextInputCell = ({
  name,
  control,
  error,
  placeholder,
  disabled = false,
}) => (
  <td>
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <input
          {...field}
          value={field.value || ""}
          placeholder={placeholder}
          disabled={disabled}
          className={clsx(styles.defaultInput, styles.inputField)}
          style={{
            border: error ? "1px solid red" : "1px solid #ccc",
            backgroundColor: disabled ? "#f8f9fa" : "white",
            cursor: disabled ? "not-allowed" : "text",
          }}
        />
      )}
    />
    {error && (
      <div style={{ color: "red", fontSize: "12px" }}>{error.message}</div>
    )}
  </td>
);

const SelectCell = ({ name, control, options, isLoading, error }) => (
  <td>
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Select
          {...field}
          value={options.find((opt) => opt.value === field.value) || null}
          onChange={(selected) => field.onChange(selected?.value)}
          options={options}
          isLoading={isLoading}
          styles={{
            control: (base) => ({
              ...base,
              width: "200px",
              minHeight: "32px",
              fontSize: "14px",
              borderColor: error ? "red" : "#ccc",
            }),
            menuList: (base) => ({ ...base, maxHeight: 160 }),
          }}
        />
      )}
    />
    {error && (
      <div style={{ color: "red", fontSize: "12px" }}>{error.message}</div>
    )}
  </td>
);

const CreatableSelectCell = ({ name, control, error }) => (
  <td>
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <CreatableSelect
          {...field}
          isMulti
          value={(field.value || []).map((label) => ({ label, value: label }))}
          onChange={(selected) => {
            const values = selected ? selected.map((item) => item.value) : [];
            field.onChange(values);
          }}
          onCreateOption={(inputValue) => {
            const cleanedValue = inputValue.trim();
            if (cleanedValue && !(field.value || []).includes(cleanedValue)) {
              field.onChange([...(field.value || []), cleanedValue]);
            }
          }}
          placeholder="Type labels..."
          styles={{
            control: (base) => ({
              ...base,
              minHeight: "32px",
              fontSize: "14px",
              borderColor: error ? "red" : "#ccc",
            }),
          }}
          formatCreateLabel={(inputValue) => `Create "${inputValue}"`}
        />
      )}
    />
    {error && (
      <div style={{ color: "red", fontSize: "12px" }}>{error.message}</div>
    )}
  </td>
);

const SwitchCell = ({ name, control }) => (
  <td style={{ textAlign: "center" }}>
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Form.Check
          type="switch"
          checked={field.value || false}
          onChange={(e) => field.onChange(e.target.checked)}
        />
      )}
    />
  </td>
);

// Enhanced Formula Input Cell with autocomplete
const FormulaInputCell = ({
  name,
  control,
  error,
  disabled,
  formulaOptions,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const inputRef = useRef(null);

  const handleFormulaChange = (value, onChange) => {
    onChange(value);

    if (disabled) return;

    const input = inputRef.current;
    if (!input) return;

    const cursor = input.selectionStart;
    const hashIndex = value.lastIndexOf("#", cursor - 1);
    const afterHash = value.slice(hashIndex + 1, cursor);

    if (hashIndex !== -1 && !/\s/.test(afterHash)) {
      const matches = formulaOptions?.filter((opt) =>
        opt.label.toLowerCase().includes(afterHash.toLowerCase())
      );
      setFilteredOptions(matches);
      setShowDropdown(true);
    } else {
      setShowDropdown(false);
    }
  };

  const handleSelect = (option, currentValue, onChange) => {
    const input = inputRef.current;
    if (!input) return;

    const cursor = input.selectionStart;
    const hashIndex = currentValue.lastIndexOf("#", cursor - 1);
    const before = currentValue.slice(0, hashIndex);
    const after = currentValue.slice(cursor);
    const newValue = `${before}#${option.label} ${after}`;

    onChange(newValue);
    setShowDropdown(false);
    input.focus();
  };

  useEffect(() => {
    const handler = (e) => {
      if (inputRef.current && !inputRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    window.addEventListener("click", handler);
    return () => window.removeEventListener("click", handler);
  }, []);

  return (
    <td>
      <div style={{ position: "relative" }}>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <>
              <input
                {...field}
                ref={inputRef}
                value={field.value || ""}
                onChange={(e) =>
                  handleFormulaChange(e.target.value, field.onChange)
                }
                placeholder="Enter formula (type # to use column names)"
                disabled={disabled}
                className={clsx(styles.formulaInput, styles.inputField)}
                style={{
                  border: error ? "1px solid red" : "1px solid #ccc",
                  backgroundColor: disabled ? "#f8f9fa" : "white",
                  cursor: disabled ? "not-allowed" : "text",
                }}
                autoComplete="off"
              />

              {showDropdown && !disabled && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    backgroundColor: "white",
                    border: "1px solid #ccc",
                    borderTop: "none",
                    maxHeight: "150px",
                    overflowY: "auto",
                    zIndex: 1000,
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  }}
                >
                  {filteredOptions.length === 0 ? (
                    <div style={{ padding: "8px", color: "#666" }}>
                      No matches
                    </div>
                  ) : (
                    filteredOptions.map((opt) => (
                      <div
                        key={opt.value}
                        style={{
                          padding: "8px",
                          cursor: "pointer",
                          borderBottom: "1px solid #eee",
                        }}
                        onMouseEnter={(e) =>
                          (e.target.style.backgroundColor = "#f8f9fa")
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.backgroundColor = "white")
                        }
                        onClick={() =>
                          handleSelect(opt, field.value, field.onChange)
                        }
                      >
                        {opt.label}
                      </div>
                    ))
                  )}
                </div>
              )}
            </>
          )}
        />
      </div>
      {error && (
        <div style={{ color: "red", fontSize: "12px" }}>{error.message}</div>
      )}
    </td>
  );
};

// Main table row component with React Hook Form
const FormTableRow = ({
  rowData,
  zohoLabels,
  columns,
  onDelete,
  fetchColumns,
}) => {
  const dataTypeOptions = [
    { value: "string", label: "String" },
    { value: "number", label: "Number" },
    { value: "boolean", label: "Boolean" },
  ];

  const zohoAssetOptions =
    zohoLabels?.map((item) => ({
      label: item?.label,
      value: item?.api_name,
    })) || [];

  const formulaOptions =
    columns?.map((item) => ({
      label: item?.label.replaceAll(" ", "_"),
      value: item?._id,
    })) || [];

  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
    watch,
  } = useForm({
    resolver: yupResolver(assetColumnSchema),
    defaultValues: {
      label: rowData?.label || "",
      zohoLabel: rowData?.zohoLabel || "",
      csvLabel: rowData?.csvLabel || [],
      dataType: rowData?.dataType || "string",
      defaultValue: rowData?.defaultValue || "",
      isFormula: rowData?.isFormula || false,
      formula: revertFormula(rowData?.formula, formulaOptions),
      // validation: {
      //   required: rowData?.validation?.required || false,
      //   minLength: rowData?.validation?.minLength || "",
      //   maxLength: rowData?.validation?.maxLength || "",
      //   min: rowData?.validation?.min || "",
      //   max: rowData?.validation?.max || "",
      // },
    },
  });
  console.log("show", errors, watch());

  const isFormula = watch("isFormula");

  const onFormSubmit = async (values) => {
    const isNew = rowData?._id?.toLowerCase()?.includes("new-");

    const formulaObj = convertFormula(values?.formula, formulaOptions);
    if (formulaObj) {
      values.formula = formulaObj?.convertedFormula;
      values.dependencies = formulaObj?.dependencies;
    }
    try {
      const res = isNew
        ? await createAssetColumn(values)
        : await updateAssetColumn(rowData?._id, values);

      fetchColumns();
      showNotification(
        "success",
        res?.message ||
          (rowData?._id
            ? "Asset updated successfully."
            : "New asset column created.")
      );
    } catch (err) {
      console.log("err", err);
      showNotification(
        "error",
        err?.response?.data?.message ||
          `Failed to ${rowData?._id ? "update" : "create"} new column.`
      );
    }
  };

  // Reset form when rowData changes
  // useEffect(() => {
  //   reset({
  //     label: rowData?.label || "",
  //     zohoLabel: rowData?.zohoLabel || "",
  //     csvLabel: rowData?.csvLabel || [],
  //     dataType: rowData?.dataType || "string",
  //     defaultValue: rowData?.defaultValue || "",
  //     isFormula: rowData?.isFormula || false,
  //     formula: revertFormula(rowData?.formula, formulaOptions),
  //     // validation: {
  //     //   required: rowData?.validation?.required || false,
  //     //   minLength: rowData?.validation?.minLength || "",
  //     //   maxLength: rowData?.validation?.maxLength || "",
  //     //   min: rowData?.validation?.min || "",
  //     //   max: rowData?.validation?.max || "",
  //     // },
  //   });
  // }, [rowData, reset]);

  return (
    <tr>
      <TextInputCell
        name="label"
        control={control}
        error={errors.label}
        placeholder="Column name"
      />

      <CreatableSelectCell
        name="csvLabel"
        control={control}
        error={errors.csvLabel}
      />

      <SelectCell
        name="zohoLabel"
        control={control}
        options={zohoAssetOptions}
        error={errors.zohoLabel}
      />

      <SelectCell
        name="dataType"
        control={control}
        options={dataTypeOptions}
        error={errors.dataType}
      />

      <TextInputCell
        name="defaultValue"
        control={control}
        error={errors.defaultValue}
        placeholder="Default value"
      />

      <SwitchCell name="isFormula" control={control} />

      <FormulaInputCell
        name="formula"
        control={control}
        error={errors.formula}
        disabled={!isFormula}
        formulaOptions={formulaOptions}
      />

      {/* Validation fields - conditional rendering based on data type */}
      {/* {(dataType === "string" || dataType === "number") && (
        <SwitchCell name="validation.required" control={control} />
      )}

      {isValidationRequired && dataType === "string" && (
        <>
          <TextInputCell
            name="validation.minLength"
            control={control}
            error={errors.validation?.minLength}
            placeholder="Min length"
          />
          <TextInputCell
            name="validation.maxLength"
            control={control}
            error={errors.validation?.maxLength}
            placeholder="Max length"
          />
        </>
      )}

      {isValidationRequired && dataType === "number" && (
        <>
          <TextInputCell
            name="validation.min"
            control={control}
            error={errors.validation?.min}
            placeholder="Min value"
          />
          <TextInputCell
            name="validation.max"
            control={control}
            error={errors.validation?.max}
            placeholder="Max value"
          />
        </>
      )} */}

      <td>
        <Button
          type="button"
          onClick={handleSubmit(onFormSubmit)}
          disabled={isSubmitting}
          variant="success"
          size="sm"
          style={{ marginRight: "8px" }}
        >
          {isSubmitting ? "Saving..." : "Save"}
        </Button>

        <Button
          type="button"
          onClick={() => onDelete(rowData._id)}
          size="sm"
          variant="danger"
          disabled={!rowData?.canDelete}
        >
          Delete
        </Button>
      </td>
    </tr>
  );
};

// Updated main table component
// const FormTable = ({ columns, rows, zohoLabels, onRowUpdate, onRowSubmit }) => {
//   const tableColumns = [
//     { label: "Column Name", field: "label" },
//     { label: "Zoho Label", field: "zohoLabel" },
//     { label: "CSV Labels", field: "csvLabel" },
//     { label: "Data Type", field: "dataType" },
//     { label: "Default Value", field: "defaultValue" },
//     { label: "Required", field: "validation.required" },
//     { label: "Formula", field: "isFormula" },
//     { label: "Actions", field: "actions" },
//   ];

//   return (
//     <table style={{ width: "100%", borderCollapse: "collapse" }}>
//       <thead>
//         <tr>
//           {tableColumns.map((header, index) => (
//             <th
//               key={index}
//               style={{
//                 padding: "12px 8px",
//                 backgroundColor: "#f8f9fa",
//                 borderBottom: "2px solid #dee2e6",
//                 textAlign: "left",
//                 fontSize: "14px",
//                 fontWeight: "600",
//               }}
//             >
//               {header.label}
//             </th>
//           ))}
//         </tr>
//       </thead>
//       <tbody>
//         {!rows.length ? (
//           <tr>
//             <td
//               colSpan={tableColumns.length}
//               style={{
//                 padding: "20px",
//                 textAlign: "center",
//                 backgroundColor: "#f8f9fa",
//                 color: "#6c757d",
//               }}
//             >
//               No Records Found.
//             </td>
//           </tr>
//         ) : (
//           rows.map((row) => (
//             <FormTableRow
//               key={row._id || row.id}
//               rowData={row}
//               zohoLabels={zohoLabels}
//               columns={columns}
//               onUpdate={onRowUpdate}
//               onSubmit={onRowSubmit}
//             />
//           ))
//         )}
//       </tbody>
//     </table>
//   );
// };

export {
  // FormTable,
  FormTableRow,
  TextInputCell,
  SelectCell,
  CreatableSelectCell,
  SwitchCell,
};
